import { BrickInfos, brick_registerer } from '@/components/bricks_infos_core.js'
import BrickVstack from '@/components/brick_vstack.vue'

let infos = new BrickInfos()

infos.back_classes = ['fas', 'fa-square', 'text-green']
infos.front_classes = ['fas', 'fa-layer-group', 'text-white']
infos.name = 'vstack'
infos.associated_class_name = 'AutomlVstackTable'
infos.editing_component_name = 'BrickVstack'
infos.editing_component = BrickVstack
infos.descriptions = {
	en: {
		short_tooltip_description: 'Vertical stacking',
		full_tooltip_description:
			'Vertical stacking of several tables (i.e. with columns the name of which represent the same entity inside all of these tables)',
		navbar_name: 'Vertical stacking',
	},
	fr: {
		short_tooltip_description: 'Empilement vertical',
		full_tooltip_description:
			'Concaténation verticale de plusieurs tables (i.e. avec des colonnes dont le même nom représente la même entité au sein de toutes ces tables)',
		navbar_name: 'Empilement vertical',
	},
}
// infos.short_tooltip_description = 'vstack_short_tooltip'
// infos.full_tooltip_description = 'vstack_full_tooltip'
// infos.navbar_name = 'vstack_navbar'
infos.background_color = 'green'

brick_registerer(infos)
